import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FilterAltOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"filter_alt_off"}/>
}
